import React, { Component } from 'react';
import { Container, Row, Button, Col } from 'reactstrap';
import ProductSidebar from '../../../../components/ProductSidebar';
import ListPage from '../../../Products/products/PBCC/pages/ListPage';
import { ForumWrapper } from 'components/ForumWrapper';
import { connect } from 'react-redux';
import { withRouter, Route, Switch, Link } from 'react-router-dom';
import { actions } from 'modules/modal';
import { actions as userActions } from 'modules/user';
import { withPhaseProvider } from 'lib/scheduleContext';
import GeneralContentContainerApiComponents from 'containers/GeneralContentContainerApiComponents';
import { faHome } from '@fortawesome/pro-regular-svg-icons/faHome';
import { faUsers } from '@fortawesome/pro-regular-svg-icons/faUsers';
import SocialPlusForum from 'components/SocialPlusForum';

// CoachingProduct Component
class CoachingProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: 'resources',
      height: 500
    };
    const thisPath = location.pathname.split('/');
    this.handleNav = this.handleNav.bind(this);
    this.messageHandler = this.messageHandler.bind(this);
    this.productSlug = location.pathname.split('/')[2];
    this.productInPath = thisPath[2];
    this.getAuthToken = this.getAuthToken.bind(this);
    this.autoJoinCommunityId = this.props.data.autoJoinCommunityId;
  }

  getAuthToken = async () => {
    const token = await this.props.retrieveSocialPlusToken(this.productInPath);
    return token;
  };

  componentDidMount() {
    window.addEventListener('message', this.messageHandler);
    if (location.hash) this.setState({ activePage: 'forum' });
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.messageHandler);
  }

  messageHandler(ev) {
    if (ev.data.type === 'dimensions' && ev.origin === 'https://www.addevent.com') {
      const h = ev.data.h;
      this.setState({ height: h });
    }
  }

  //navigation
  handleNav(name, typeOfComponent, slug) {
    this.props.history.push(`/products/${this.productInPath}/${slug}`);
    window.scrollTo(0, 0);
  }

  render() {
    const { activePage, height } = this.state;
    const {
      Children,
      location,
      history,
      user,
      data: { socialPlusApiKey }
    } = this.props;

    const carousels = Children?.filter(c => c.type === 'list');
    const embedUrl = Children?.find(c => c.type === 'link' && c.title.includes('Calendar'))?.data?.url;
    const zoomUrl = Children?.find(c => c.type === 'link' && c.title.includes('Zoom'))?.data?.url;

    const { userId, firstName, lastName } = user;
    const userIdString = userId.toString();
    const displayName = `${firstName} ${lastName.charAt(0).toUpperCase()}`;

    return (
      <ProductSidebar
        navItems={[
          {
            name: 'Home',
            icon: faHome,
            typeOfComponent: 'Dashboard',
            slug: ''
          },
          {
            name: 'Community',
            icon: faUsers,
            typeOfComponent: 'SocialPlus',
            slug: 'community'
          }
        ]}
        handleNav={this.handleNav}
      >
        <Switch>
          <Route
            exact
            path={`/products/${this.productSlug}/`}
            render={() => (
              <Container style={{ minHeight: '100vh' }}>
                <Row>
                  <Col>
                    <h4>Coaching Program Dashboard</h4>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    {embedUrl ? (
                      <iframe
                        className="mt-5"
                        src={embedUrl}
                        style={{ width: '100%', height: `${height}px`, border: 0 }}
                      />
                    ) : null}
                  </Col>
                </Row>
                <Row className="justify-content-center">
                  <Col className="text-center">
                    {zoomUrl ? (
                      <Button color="primary" className="mt-5" onClick={() => window.open(zoomUrl, '_blank')}>
                        Private Coaching Room
                      </Button>
                    ) : null}
                  </Col>
                </Row>
                {carousels && carousels.length ? (
                  <ListPage
                    {...this.props}
                    location={location}
                    history={history}
                    title="Coaching Resources"
                    Children={carousels}
                  />
                ) : (
                  <em>No Resources Available</em>
                )}
              </Container>
            )}
          />
          <Route
            exact
            path={`/products/${this.productSlug}/community`}
            render={() => <SocialPlusForum autoJoinCommunityId={this.autoJoinCommunityId} />}
          />
          <Route
            key={'wildcard'}
            exact
            path={`/products/${this.productSlug}/:slug/`}
            component={props => (
              <Container style={{ minHeight: '100vh' }}>
                <GeneralContentContainerApiComponents
                  dataMassager={null}
                  Component={null}
                  componentProps={{ showComments: this.productSlug === 'pbcc' }}
                />
              </Container>
            )}
          />
        </Switch>
      </ProductSidebar>
    );
  }
}

// Redux Connect
const mapStateToProps = state => ({
  user: state.user
});

const mapDispatchToProps = dispatch => ({
  get: contentId => dispatch(actions.getUserData(contentId)),
  post: (contentId, data) => dispatch(actions.postUserData(contentId, data)),
  retrieveSocialPlusToken: productSlug => dispatch(userActions.retrieveSocialPlusToken(productSlug)),
  refreshToken: userActions.refreshToken,
  revokeDiscourseAPIKey: userActions.revokeDiscourseAPIKey
});

const ConnectedListProduct = connect(mapStateToProps, mapDispatchToProps)(CoachingProduct);
const EnhancedListProduct = withPhaseProvider(withRouter(ConnectedListProduct));
export default withRouter(EnhancedListProduct);
